import React from 'react';
import { Label } from '@core-ui/Components/ui/label';
import { ENV } from '@constants/env.ts';
import constants from '@constants/constants.json';
import { IconAlertTriangleFilled } from '@tabler/icons-react';

interface Props {
  isOpen?: boolean;
}

export function EnvVersionBanner ({ isOpen }: Props): React.JSX.Element | null {
  const env = ENV;
  const envVersion = constants.version;

  let content: string;
  let contentOpen: string = '';

  switch (env) {
  case 'local':
    content = `Local env - ${envVersion}`;
    break;

  case 'qa':
    content = `Alpha env - ${envVersion}`;
    break;

  case 'preprod':
    content = `Beta env - ${envVersion}`;
    break;

  case 'prod':
    content = `${envVersion}`;
    contentOpen = `v - ${envVersion}`;
    break;

  default:
    return null;
  }

  return env === 'prod' ? (
    <div className="flex justify-center">
      <Label
        className="inline-flex items-center p-1.5 gap-1
               bg-[var(--env-banner-info)]
               text-[var(--primary-foreground)] border border-border
               rounded-md whitespace-nowrap"
      >
        {(isOpen === true) ? contentOpen : content}
      </Label>
    </div>

  ) : (
    <Label
      className="flex items-center h-7.5 w-auto gap-2
               bg-[var(--env-banner-info)]
               text-[var(--primary-foreground)] border border-border
               rounded-md whitespace-nowrap px-2 py-1"
    >
      <>
        <IconAlertTriangleFilled
          className="h-5 w-5 text-[var(--primary-foreground)]"
        />
        {content}
      </>

    </Label>
  );
}
